import { fetchGroupAttributes } from '@gn-audio/core/api/product-catalogue/fetch-group-attributes';
import { fetchGroupImages } from '@gn-audio/core/api/product-catalogue/fetch-group-images';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
import { isImage } from '../utils/is-image';
var ProductInformationSpotController = (function () {
    function ProductInformationSpotController($scope, $q, productContextService) {
        this.$scope = $scope;
        this.$q = $q;
        this.productContextService = productContextService;
        this.pageRegex = /^(\/[a-z]{2}-[a-z]{2,4})?(?<page_path>\/supportpages\/[^\/]+)\/(?<sku>[a-z0-9\-]+)\/.*$/gi;
    }
    ProductInformationSpotController.prototype.$onInit = function () {
        var _this = this;
        var sku = this.getSkuFromUrl();
        this.$q
            .when(fetchProductsBySkus([sku.toUpperCase()], "supported"))
            .then(function (products) {
            if (products === void 0) { products = []; }
            _this.$scope.contextProduct = products[0];
        })
            .then(function () {
            _this.$q
                .when(fetchGroupImages(_this.$scope.contextProduct.groupId, "supported"))
                .then(function (images) {
                if (images === void 0) { images = []; }
                _this.$scope.contextImages = images.filter(isImage);
            });
            _this.$q
                .when(fetchGroupAttributes(_this.$scope.contextProduct.groupId, "supported"))
                .then(function (group) {
                if (!group) {
                    return;
                }
                _this.$scope.contextGroup = group;
                _this.productContextService.setContext(group);
            });
        });
    };
    ProductInformationSpotController.prototype.getContextProductSupportPageUrl = function () {
        if (!this.$scope.contextGroup) {
            return undefined;
        }
        var _a = this.$scope.contextGroup, sku = _a.sku, supportPageUrl = _a.supportPageUrl;
        return supportPageUrl + "#/#" + sku;
    };
    ProductInformationSpotController.prototype.isDiscontinued = function () {
        if (!this.$scope.contextGroup) {
            return;
        }
        var groupState = this.$scope.contextGroup.groupState;
        return groupState < 3;
    };
    ProductInformationSpotController.prototype.getSkuFromUrl = function () {
        var matched = this.pageRegex.exec(location.pathname);
        if (!matched || !matched.groups || !matched.groups.sku) {
            console.warn('Failed to extract SKU from location path.');
            return;
        }
        return matched.groups.sku;
    };
    ProductInformationSpotController.$inject = ['$scope', '$q', 'productContextService'];
    return ProductInformationSpotController;
}());
export { ProductInformationSpotController };
